import { memo } from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/input';
import { FILTER_OPTIONS, FilterOption } from '../utils/vendorConstants';

interface VendorFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedFilter: FilterOption;
  onFilterChange: (filter: FilterOption) => void;
}

function VendorFilters({
  searchQuery,
  onSearchChange,
  selectedFilter,
  onFilterChange,
}: VendorFiltersProps) {
  return (
    <div className="flex items-center space-x-4">
      <div className="flex-1 relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
        <Input
          placeholder="Search vendors by name, contact, phone, or email..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-12 h-12"
        />
      </div>

      <div className="flex space-x-2">
        {FILTER_OPTIONS.map((filter) => (
          <button
            key={filter}
            onClick={() => onFilterChange(filter)}
            className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
              selectedFilter === filter
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {filter.charAt(0).toUpperCase() + filter.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(VendorFilters);
